import React from 'react';
import { Box, Paper, Typography, Button } from '@mui/material';
import BusinessRoundedIcon from '@mui/icons-material/BusinessRounded';
import AccountTreeRoundedIcon from '@mui/icons-material/AccountTreeRounded';
import { useNavigate } from 'react-router-dom';
import { OFFICE_REGISTER, HIERARCHY_REGISTER } from '../../routes/routes';
import { tokens } from '../../theme/tokens';

const useEmptyStateConfig = () => {
  const navigate = useNavigate();

  return {
    owned: {
      icon: <BusinessRoundedIcon sx={{ fontSize: 56, color: tokens.colors.muted2 }} />,
      title: 'No tienes despachos propios',
      description:
        'Crea tu primer despacho para comenzar a gestionar tu práctica legal',
      action: (
        <Button
          variant="contained"
          startIcon={<BusinessRoundedIcon />}
          onClick={() => navigate(OFFICE_REGISTER)}
          size="large"
        >
          Crear Primer Despacho
        </Button>
      ),
    },
    member: {
      icon: <BusinessRoundedIcon sx={{ fontSize: 56, color: tokens.colors.muted2 }} />,
      title: 'No eres miembro de ningún despacho',
      description: 'Solicita acceso a un despacho o espera a ser invitado',
      action: null,
    },
    hierarchy: {
      icon: <AccountTreeRoundedIcon sx={{ fontSize: 56, color: tokens.colors.muted2 }} />,
      title: 'No hay jerarquías configuradas',
      description: 'Crea tu primera jerarquía para organizar áreas, formas y tipos',
      action: (
        <Button
          variant="contained"
          startIcon={<AccountTreeRoundedIcon />}
          onClick={() => navigate(HIERARCHY_REGISTER)}
          size="large"
        >
          Crear Jerarquía
        </Button>
      ),
    },
  };
};

const EmptyState = ({ type }) => {
  const config = useEmptyStateConfig();
  const { icon, title, description, action } = config[type] || {};

  return (
    <Paper
      elevation={0}
      sx={{
        p: 6,
        textAlign: 'center',
        backgroundColor: tokens.colors.panel2,
        borderRadius: `${tokens.radius.lg}px`,
        border: `2px dashed ${tokens.colors.line2}`,
      }}
    >
      <Box sx={{ mb: 2 }}>{icon}</Box>
      <Typography variant="h6" color="text.secondary" gutterBottom>
        {title}
      </Typography>
      <Typography variant="body2" color="text.secondary" sx={{ mb: 3 }}>
        {description}
      </Typography>
      {action}
    </Paper>
  );
};

export default EmptyState;